import { AbstractPathResolver, PathResolveResult } from '../PathResolver';

export class BecomeASellerPathResolver extends AbstractPathResolver {
  resolveStateFromPath(): PathResolveResult {
    if (this.context.path === '/become-a-seller') {
      const defaultState = this.getDefaultState({
        screens: {
          becomeASeller: this.context.options?.screens?.becomeASeller,
        },
      });
      return {
        index: 1,
        routes: [
          { name: 'home' },
          ...(defaultState?.routes ?? [{ name: 'becomeASeller' }]),
        ],
      };
    }
  }
}
